import { PaginationResults } from "@/lib/type";
import { createApi } from "@reduxjs/toolkit/query/react";
import { Notification, NotificationQuery } from "./notification.type";
import { baseQueryWithLogout } from "@/lib/baseQuery";

export const NotificationApi = createApi({
  reducerPath: "notificationApi",
  tagTypes: ["notification"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getNotifications: build.query<
      PaginationResults<Notification>,
      { query?: NotificationQuery }
    >({
      query: ({ query }) => ({
        url: "notifications",
        method: "GET",
        params: query,
      }),
      providesTags: ["notification"],
      transformResponse: (data: any) => {
        return {
          results: data["hydra:member"],
          count: data["hydra:totalItems"],
        };
      },
    }),

    updateNotification: build.mutation<
      Notification,
      { id: string; isRead: boolean }
    >({
      query: ({ id, isRead }) => ({
        url: `notifications/${id}`,
        method: "PATCH",
        headers: {
          "Content-Type": "application/merge-patch+json",
        },
        body: JSON.stringify({ isRead }),
      }),
      invalidatesTags: ["notification"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useUpdateNotificationMutation,
} = NotificationApi;
